module.exports = __webpack_public_path__ + "media/components/src/assets/images/account_circle/account_circle_black_24dp-6faae850dd2d5f1e7dd6a05d15d3cdc0.svg";